import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { StorageService } from '@services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionIdGuard {
  private storageService = inject(StorageService);

  /**
   * Determines if the route page should be loaded.
   *
   * @returns {boolean} true if the user is allowed to activate the route, false otherwise
   */
  public canActivate(): boolean {
    if (!!this.storageService.transactionId) {
      return true;
    }

    window.location.href = environment.siteUrls.tests;

    return false;
  }
}
